<div class="container" *ngIf="errorMessage === ''">
    <div class="header">
        <div class="header-content">
            <span class="custom1">VER TANQUE</span>
        </div>
        <span class="header-text custom2">Ver datos de tanque DataBeer</span>
    </div>

    <div class="body">

        <!--DATOS TANQUE-->

        <div class="datos-instalacion">
            <div class="datos-dispositivo-header">
                <span>DATOS DEL TANQUE</span>
            </div>

            <mat-form-field class="etiqueta-container marginTop30" appearance="outline">
                <mat-label class="etiqueta-label">Identificador Único</mat-label>
                <input matInput type="text" [(ngModel)]="identificadorCliente" placeholder="Identificador del tanque" [readonly]="true">
            </mat-form-field>

            <form [formGroup]="customPositionFormGroup" class="marginTopM15">
                <mat-form-field class="etiqueta-container" appearance="outline">
                    <mat-label class="etiqueta-label" [ngClass]="{'error-select': customNumeroTanqueError}">Número de tanque</mat-label>
                    <input matInput type="text" formControlName="customPosition" placeholder="Número de tanque en el establecimiento" [readonly]="true">
                </mat-form-field>
            </form>

            <!--<mat-form-field class="etiqueta-container" style="margin-top: 0px;">
                <mat-label class="etiqueta-label">Nº de tanque</mat-label>
                <input matInput type="text" [(ngModel)]="nTanque">
                <button *ngIf="nTanque" matSuffix mat-icon-button aria-label="Clear" (click)="nTanque=''">
                  <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>-->

            <form [formGroup]="capacidadFormGroup" class="marginTopM15">
                <mat-form-field class="etiqueta-container" appearance="outline">
                    <mat-label class="etiqueta-label" [ngClass]="{'error-select': capacidadError}">Capacidad del tanque</mat-label>
                    <input matInput type="text" formControlName="capacidadTanque" [readonly]="true">
                </mat-form-field>
            </form>

            <form class="marginTopM15">
                <mat-form-field class="etiqueta-container" appearance="outline">
                    <mat-label class="etiqueta-label" [ngClass]="{'error-select': capacidadError}">Tipo de Cerveza:</mat-label>
                    <input matInput type="text" [value]="devolverNombreCerveza()" [readonly]="true">
                </mat-form-field>
            </form>

        <!--CONFIGURACIÓN DE ALARMAS-->

            <div class="rango-alarmas-header">
                <span>CONFIGURACIÓN DE ALARMAS</span>
            </div>

            <form [formGroup]="configuracionAlarmas">
                <mat-form-field class="etiqueta-container marginTop40" appearance="outline">
                    <mat-label class="etiqueta-label">Nivel mínimo de cerveza (%)</mat-label>
                    <input matInput type="text" formControlName="nivelCerveza" [readonly]="true">
                </mat-form-field>
            </form>

            <div class="marginTop5">
                <span class="custom3">Temperatura: </span>

                <div class="custom4">
                    <form [formGroup]="configuracionAlarmas" class="custom5">
                        <mat-form-field class="etiqueta-container marginTop20" appearance="outline">
                            <mat-label class="etiqueta-label">Mínimo (ºC)</mat-label>
                            <input matInput type="text" formControlName="temperaturaTanqueMin" [readonly]="true">
                        </mat-form-field>
                    </form>
        
                    <form [formGroup]="configuracionAlarmas" class="width475">
                        <mat-form-field class="etiqueta-container marginTop20" appearance="outline">
                            <mat-label class="etiqueta-label">Máximo (ºC)</mat-label>
                            <input matInput type="text" formControlName="temperaturaTanqueMax" [readonly]="true">
                        </mat-form-field>
                    </form>
                </div>
            </div>

            <div class="marginTop5">
                <span class="custom3">Presión: </span>

                <div class="custom4">
                    <form [formGroup]="configuracionAlarmas" class="custom5">
                        <mat-form-field class="etiqueta-container marginTop20" appearance="outline">
                            <mat-label class="etiqueta-label">Mínimo (Bares)</mat-label>
                            <input matInput type="text" formControlName="presionMin" [readonly]="true">
                        </mat-form-field>
                    </form>
        
                    <form [formGroup]="configuracionAlarmas" class="width475">
                        <mat-form-field class="etiqueta-container marginTop20" appearance="outline">
                            <mat-label class="etiqueta-label">Máximo (Bares)</mat-label>
                            <input matInput type="text" formControlName="presionMax" [readonly]="true">
                        </mat-form-field>
                    </form>
                </div>
            </div>
        </div>

        <!--INSTALACION-->

        <div class="datos-dispositivo">
            <div class="datos-instalacion-header">
                <span>DATOS DE LA INSTALACIÓN</span>
            </div>

            <form class="marginTop10">
                <mat-form-field class="etiqueta-container" appearance="outline">
                    <mat-label class="etiqueta-label" [ngClass]="{'error-select': capacidadError}">Dispositivo:</mat-label>
                    <input matInput type="text" [value]="nombreDispositivo" [readonly]="true">
                </mat-form-field>
            </form>

            <div>
                <span class="custom3">Establecimiento: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [readonly]="true" value="{{establecimientoNombre}}"/>
                </mat-form-field>
            </div>

            <div>
                <mat-label class="etiqueta-label" [ngClass]="{'error-select': numeroTanqueError}">Posición: </mat-label> <span> Disponible en el dispositivo</span>
            </div>
            <form class="marginTopM5">
                <mat-form-field class="etiqueta-container" appearance="outline">
                    <input matInput type="text" [value]="tanqueSeleccionado" [readonly]="true">
                </mat-form-field>
            </form>

            <div class="mapa-container marginTop5">
                <div class="marginBottom20">
                    <span class="custom3">Ubicación del establecimiento: </span>
                </div>
                <div id="map" class="height450"></div>
                <!--<agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom" [mapTypeControl]="true" mapTypeId="hybrid">
                    <agm-marker [latitude]="lat" [longitude]="lng"></agm-marker>
                </agm-map>-->
            </div>

            <div class="etiqueta-container marginTop30">
                <span class="custom3">Dirección completa: </span>
                <mat-form-field appearance="outline" class="latitud-value marginTop10">
                    <input matInput type="text" [readonly]="true" value="{{addressData}}"/>
                </mat-form-field>
            </div>

            <form *ngIf="userData.pro_id == 4">
                <mat-form-field class="etiqueta-container" appearance="outline">
                    <mat-label class="etiqueta-label" [ngClass]="{'error-select': capacidadError}">Cliente:</mat-label>
                    <input matInput type="text" [value]="devolverCliente()" [readonly]="true">
                </mat-form-field>
            </form>
        </div>
    </div>
</div>
<div class="footer"></div>

